export const AnswerStatus = {
  Checked: "checked",
  CorrectChecked: "correctChecked",
  WrongChecked: "wrongChecked",
  WrongUnchecked: "wrongUnchecked",
  Default: "default",
};
